import React from 'react';
import SMFormatHelper from 'components/helpers/SMFormatHelper';
import SMReservationStatusView from 'components/dashboard/shared/SMReservationStatusView';
import SMDashboardUserBaloonView from 'components/dashboard/shared/SMDashboardUserBaloonView';
import SMAppHelper from 'components/helpers/SMAppHelper';
import SMReservationUnapprovedView from 'components/dashboard/shared/SMReservationUnapprovedView';

class SMUReservationUnapprovedView extends SMReservationUnapprovedView {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const reservation = this.props.reservation;
    const unapproved_reservation = this.props.unapproved_reservation;

    let authRows = [];
    let members = null;

    const baloonType = "Owner";
    const baloonData = JSON.stringify(reservation.owner);
    const baloonButtonTitle = I18n.t("dashboard.label_000097");
    const baloonButtonLink = Routes.dashboard_message_path(reservation.uid);
    const name = SMFormatHelper.ownerName(reservation.owner);
    const link = Routes.owner_path(reservation.owner.username);
    const image = SMFormatHelper.ownerImageUrl(reservation.owner, reservation.owner.profile_image);
    const needPreview = reservation.need_preview ? I18n.t("dashboard.label_000710") : null;
    const isAppliedCoupon = reservation.billing && reservation.billing.is_applied_coupon ?
      <p className="reserve-header__coupon">{I18n.t("dashboard.label_000705")}</p> : null;

    if (reservation.owner.is_verified_email) {
      authRows.push(SMFormatHelper.renderEmailIcon());
    }
    if (reservation.owner.is_verified_tel) {
      authRows.push(SMFormatHelper.renderTelIcon());
    }

    if (unapproved_reservation.is_need_number_of_guests && reservation.is_need_number_of_guests)  {
      members = <p className="reserve-header__name-supplement"><del className="mr5">{reservation.number_of_guests}{I18n.t("dashboard.label_000213")}</del><ins>{unapproved_reservation.number_of_guests}{I18n.t("dashboard.label_000213")}</ins></p>;
    } else if (unapproved_reservation.is_need_number_of_guests) {
      members = <p className="reserve-header__name-supplement">{unapproved_reservation.number_of_guests}{I18n.t("dashboard.label_000213")}</p>;
    }

    return (
      <div className="maincol-lightbox maincol-lightbox__reserve-change" style={{position: "absolute"}}>
        <div className="form-casette maincol-lightbox__form reserve-change">

          <h2 className="dashboard-title mb30 ta-c">
            ホストから予約変更リクエストが送信されました。<br />
            内容を確認後、承諾もしくは却下してください。
          </h2>

          <div className="reserve-header">
            <SMReservationStatusView reservation={reservation} className="reserve-header__status reserve-status-icon" />
            <p className="reserve-header__id">予約ID：{reservation.id}</p>
            {this.renderReservedDateText()}
            <div className="reserve-header__affiliation">
              <SMDashboardUserBaloonView
                user={reservation.user}
                owner={reservation.owner}
                link={link}
                target='_blank'
                baloonType={baloonType}
                baloonData={baloonData}
                baloonButtonTitle={baloonButtonTitle}
                baloonButtonLink={baloonButtonLink}
                image={image}
                className="js-baloon reserve-header__img"
                name={name} />
              <p className="reserve-header__name">
                { (!reservation.owner || SMAppHelper.ownerIsDeleted(reservation.owner)) ? name :
                  <a href={link} target="_blank">{name}</a>}
              </p>
              {members}
              <p className="reserve-header__company"></p>
              <p className="reserve-header__icon">
                {authRows}
              </p>
            </div>

            {this.renderSpace()}
            {this.renderPrice(false)}
          </div>
          {this.renderBilling(false)}
          {this.renderDueDate()}
          <div className="mt20 mb30 ta-c">
            <a href="#" onClick={this.reject.bind(this)} className="button button-gray maincol-buttonarea__button">{I18n.t("dashboard.label_000212")}</a>
            <a href="#" onClick={this.confirm.bind(this)} className="button button-green maincol-buttonarea__button">{I18n.t("dashboard.label_000211")}</a>
          </div>
        </div>
      </div>
    );
  }
}
export default SMUReservationUnapprovedView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationUnapprovedView.jsx